export const totalPrice = (customConfigData) => {
  return customConfigData?.orderDetails
    ?.map((item) => (item?.includeBike === false ? 0 : parseInt(item?.Price)))
    ?.reduce((prev, next) => parseInt(prev) + parseInt(next));
};
